import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ForgotPasswordModal from './ForgotPasswordModal'; // ✅ Import modal
import './AdminLogin.css';
import { API_BASE_URL } from '../config/apiConfig';

function AdminLogin({ setToken }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // ✅ Modal state
  const navigate = useNavigate();


  useEffect(() => {
    setMessage('');
  }, [username, password]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      const data = await res.json();

      if (res.ok) {
        const expiryTime = Date.now() + 60 * 60 * 1000; // 1 hour from now
        localStorage.setItem('adminToken', data.token);
        localStorage.setItem('adminTokenExpiry', expiryTime.toString());
        localStorage.setItem('adminUser', username);
        setToken(data.token);
        navigate('/admin/dashboard');
      } else {
        setMessage(data.message || 'Login failed');
      }
    } catch {
      setMessage('Network error: Unable to reach server');
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <form className="login-form" onSubmit={handleLogin}>
        <h2>🔐 Admin Login</h2>

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>

        {message && <p className="login-message">{message}</p>}

        {/* 🧭 Updated Options */}
        <div className="login-links">
          <span onClick={() => setIsModalOpen(true)}>Forgot password?</span>
          <span>|</span>
          <span onClick={() => navigate('/admin/register')}>Register</span>
        </div>
      </form>

      {/* 🧵 Modal Integration */}
      <ForgotPasswordModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}

export default AdminLogin;
